import React, { useState } from "react";
import { Tabs, Tab, Box, Paper } from "@mui/material";
import Layout from "../../Layout";
import Dashboard from "./index";
import MaintenanceDashboard from "../MaintenanceDashboard";
import { checkPrivileges } from "../../Helpers";



const MainDashboardFile = (props) => {
    const [activeTab, setActiveTab] = useState(0);
    // const user = props.user;

    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
    };
    if (!checkPrivileges("maintenanceDashboard")) {
        return (
            <Layout {...props} noSidebar classFromChildren={"has-padding no-sidebar dashboard-page"}>
                <Dashboard {...props}/>
            </Layout>
        );
    }
    return (
        <Layout {...props} noSidebar classFromChildren={"has-padding no-sidebar dashboard-page"}>
            <Box display="flex" justifyContent="start">
                <Paper elevation={3} sx={{ width: "35%", borderRadius: 2 }}>
                    <Tabs
                        value={activeTab}
                        onChange={handleChange}
                        textColor="#ffffff"
                        indicatorColor="primary"
                        variant="fullWidth"
                        sx={{
                            "& .MuiTab-root": {
                                fontWeight: "bold",
                                color: "#ffffff",
                                backgroundColor: "#0A83A1",
                            },
                            "& .Mui-selected": {
                                color: "#ffffff",
                                backgroundColor: "#045266",
                            },
                            "& .MuiTabs-indicator": {
                                backgroundColor: "#0A83A1",
                                color:"white",
                                height: 3,
                                borderRadius: 2,
                            },
                        }}
                    >
                        <Tab label="Dashboard" />
                        <Tab label="Maintenance Dashboard" />
                    </Tabs>
                </Paper>
            </Box>

            <Box sx={{ mt: 1}}>
                {activeTab === 0 && <Dashboard {...props}/>}
                {activeTab === 1 && <MaintenanceDashboard {...props}/>}
            </Box>
        </Layout>
    );
};

export default MainDashboardFile;
